import { useMemo } from "react";

import {
  EditFlowType,
  getEditFlowType,
  isLastStepInCoverEdit,
  isQuoteReviewCoverEdit,
} from "../common-utils/edit-quote-review-summary-flow.utils";

/**
 * Custom hook to determine the current edit flow type
 *
 * @param editPageParam - Edit page URL parameter (e.g., from searchParams.get('coverEdit'))
 * @returns Object containing edit flow information
 *
 * @example
 * ```tsx
 * const searchParams = useSearchParams();
 * const editPage = searchParams.get(CoverEdit);
 * const { flowType, isQuoteReviewEdit, isLastStep } = useEditFlowType(editPage);
 * ```
 */
export function useEditFlowType(editPageParam: string | null) {
  const flowType = useMemo(
    () => getEditFlowType(editPageParam),
    [editPageParam]
  );

  const isQuoteReviewEdit = useMemo(
    () => isQuoteReviewCoverEdit(editPageParam),
    [editPageParam]
  );

  const isLastStep = useMemo(
    () => isLastStepInCoverEdit(editPageParam),
    [editPageParam]
  );

  const isNormalFlow = flowType === EditFlowType.NORMAL_FLOW;
  const isQuotePageEdit = flowType === EditFlowType.QUOTE_PAGE_EDIT;

  return {
    flowType,
    isQuoteReviewEdit,
    isQuotePageEdit,
    isNormalFlow,
    isLastStep,
  };
}
